<template>
  <div class="message full-height">
    <ld-header @click-right="$router.push({path: '/noticeList'})">
      <template #left>
        <span class="font24 font-bold">消息中心</span>
      </template>
      <template #right>
        <van-badge :dot="!!(badgeDotCount.message && badgeDotCount.message > 0)">
          <span class="main-color">查看未读</span>
        </van-badge>
      </template>
    </ld-header>
    <!-- qgehomewrapper -->
    <div class="oiuytre">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div class="box" />
        <div
          v-for="(item, index) in menuList"
          :key="index"
          @click="$router.push({path:item.link,query: {msgType:item.msgType}})"
        >
          <van-cell
            v-show="item.show"
            is-link
            :title="item.title"
            center
            size="large"
          >
            {{ item.msgDate }} 
            <template #icon>
              <van-badge :content="item.unReadNum ? item.unReadNum : undefined">
                <svg
                  class="svg-icon font30"
                  aria-hidden="true"
                >
                  <use :xlink:href="`#${item.icon}`" />
                </svg>
              </van-badge>
              &nbsp;
            </template>
          </van-cell>
          <div :class="[index==2 ? 'box' : '']" />
        </div>
      </mescroll-vue>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Grid, GridItem, Icon, NoticeBar, Cell, Image as VanImage, Badge } from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'

import approval from 'Components/Dynamic/btlh/images/message/approval.png'
import advice from 'Components/Dynamic/btlh/images/message/advice.png'
import message from 'Components/Dynamic/btlh/images/message/message.png'
import pay from 'Components/Dynamic/btlh/images/message/pay.png'
import order from 'Components/Dynamic/btlh/images/message/order.png'
import kf from 'Components/Dynamic/btlh/images/message/kf.png'


export default {
  name: 'Message',
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [Cell.name]: Cell,
    [VanImage.name]: VanImage,
    [Badge.name]: Badge,
    MescrollVue,
  },
  data () {
    return {
      down:{ use: false },
      kfShow: false,
      kf,
      menuList: [
        {
          link: '/userCenter/message/list',
          title: '审批信息',
          icon:'iconweibiaoti-127',
          msgType:3,
          msgDate: '',
          show:true,
          img: order,
        },
        {
          link: '/userCenter/message/list',
          title: '航变信息',
          icon:'iconweibiaoti-128',
          msgType:4,
          msgDate: '',
          show:true,
          img: approval
        },
        {
          link: '/userCenter/message/order',
          title: '订单通知',
          icon:'iconweibiaoti-129',
          msgType:2,
          msgDate: '',
          show:true,
          img: message
        },
        {
          link: '/userCenter/message/list',
          title: '系统消息',
          icon:'iconweibiaoti-130',
          msgType:1,
          msgDate: '',
          show:true,
          img: pay
        },
        {
          link: '/userCenter/message/list',
          title: '企业通知',
          icon:'iconweibiaoti-131',
          msgType:5,
          msgDate: '',
          show:true,
          img: advice
        },
        {
          link: '/userCenter/message/list',
          title: '客服消息',
          icon:'iconweibiaoti-132',
          msgType:6,
          msgDate: '',
          show:false,
          img: advice
        }
      ],
      orderList:[]
    }
  },
  computed: {
    ...mapGetters(['loginConfig', 'userInfo', 'loginNotices', 'badgeDotCount'])
  },
  created () {
    this.getNoticeType()
    this.getLoginNotice(0)
  },
  mounted () {
  },
  methods:{
    ...mapActions(['getLoginNotice']),
    /**
     * 获取消息类型
     */
    getNoticeType() {
      this.$api['common/allGgTz']().then(res=>{
        var cache=res.data||[]
        this.menuList.forEach(item => {
          item.show = cache.some(el => el.msgType == item.msgType)

          var msg = cache.find(el => el.msgType == item.msgType)
          if (msg) {
            item.msgDate = msg.msgDate
            item.unReadNum = msg.unReadNum
          }
        })
      })
    }
  },
}
</script>

<style lang="less" scoped>
.box{
  padding:5px 0;
}
</style>
